// src/components/CommentBox.tsx

import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { postComment, Comment as CommentType } from '../api/comments';
import MentionInput from './MentionInput';

interface AppUser {
    email: string;
}

interface CommentBoxProps {
    revisionGroupId: string;
    onNewComment: (newComment: CommentType) => void;
    allUsers: AppUser[];
}

const CommentBox: React.FC<CommentBoxProps> = ({
    revisionGroupId,
    onNewComment,
    allUsers,
}) => {
    const [focused, setFocused] = useState(false);
    const [body, setBody] = useState('');

    const handleSubmit = async () => {
        const html = body.trim();
        if (!html) return;

        try {
            const newComment = await postComment(revisionGroupId, html); // use HTML
            onNewComment(newComment);
            setBody('');
            setFocused(false);
        } catch (err) {
            console.error('Failed to post comment:', err);
        }
    };

    const handleCancel = () => {
        setBody('');
        setFocused(false);
    };

    return (
        <Box
            sx={{
                mt: 6,
                pt: 3,
                width: { xs: '100%', sm: '80%' },
                position: 'relative',
            }}
        >
            {!focused ? (
                <Box
                    onClick={() => setFocused(true)}
                    sx={{
                        color: 'text.secondary',
                        cursor: 'text',
                        px: 1,
                        py: 1.5,
                        borderBottom: '1px solid #ccc',
                    }}
                >
                    Add a comment…
                </Box>
            ) : (
                <>
                    <MentionInput
                        value={body}
                        onChange={setBody}
                        onSubmit={handleSubmit}
                        onCancel={handleCancel}
                        allUsers={allUsers}
                        autoFocus
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                            mt: 1,
                        }}
                    >
                        <Button variant="text" onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={handleSubmit}>
                            Comment
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    );
};

export default CommentBox;
